import {Vue, Component} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const userAgent = namespace('userAgent')

/**
 * IE 브라우저에서 input readonly attribute 사용 시 bug fix
 * @mixin
 */
@Component
export default class PopupHandler extends Vue {
  @userAgent.Getter('isIE') isIE: boolean

  /*
   * input에 focus 커서가 남아있는 버그 픽스
   */
  handleFocus(e) {
    if(this.isIE) {
      e.target.blur()
    }
  }
}
